var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-search-wrap" },
    [
      _c(
        "form",
        { staticClass: "product-search-form" },
        [
          _c("div", { staticClass: "inline-search-fields" }, [
            _c("div", { staticClass: "inline-field" }, [
              _c("div", { staticClass: "field-name" }, [
                _vm._v(_vm._s(_vm.$t("Product name (or sku Id)")))
              ]),
              _c("div", { staticClass: "field-value" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchData.name,
                      expression: "searchData.name"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.searchData.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.searchData, "name", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "inline-field" }, [
              _c("div", { staticClass: "field-name" }, [
                _vm._v(_vm._s(_vm.$t("Price")))
              ]),
              _c("div", { staticClass: "field-value field-value-inline" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.searchData.price.from,
                      expression: "searchData.price.from",
                      modifiers: { number: true }
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.searchData.price.from },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.searchData.price,
                        "from",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _c("span", { staticClass: "slash" }, [_vm._v("-")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.searchData.price.to,
                      expression: "searchData.price.to",
                      modifiers: { number: true }
                    }
                  ],
                  attrs: { type: "number" },
                  domProps: { value: _vm.searchData.price.to },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.searchData.price,
                        "to",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(
                  "\n                    " +
                    _vm._s(" " + _vm.currencySign) +
                    "\n                "
                )
              ])
            ]),
            _c("div", { staticClass: "inline-field" }, [
              _c("div", { staticClass: "field-name" }, [
                _vm._v(_vm._s(_vm.$t("Search in category")))
              ]),
              _c("div", { staticClass: "field-value" }, [
                _vm.isDataLoading
                  ? _c("div", { staticClass: "loader" })
                  : _c(
                      "div",
                      [
                        _c("multiselect", {
                          attrs: {
                            placeholder: _vm.$t("Select category"),
                            label: "name",
                            "track-by": "id",
                            options: _vm.categoriesList,
                            showLabels: false,
                            multiple: false
                          },
                          model: {
                            value: _vm.searchData.category,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "category", $$v)
                            },
                            expression: "searchData.category"
                          }
                        })
                      ],
                      1
                    )
              ])
            ]),
            _c("div", { staticClass: "inline-field" }, [
              _c("div", { staticClass: "field-name" }, [
                _vm._v(_vm._s(_vm.$t("Skus")))
              ]),
              _c(
                "div",
                { staticClass: "field-value" },
                [
                  _c("base-checkbox", {
                    attrs: {
                      label: _vm.$t("Show skus in results"),
                      checked: _vm.searchData.showSkus
                    },
                    model: {
                      value: _vm.searchData.showSkus,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "showSkus", $$v)
                      },
                      expression: "searchData.showSkus"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "inline-field" }, [
              _c("div", { staticClass: "field-name" }, [
                _vm._v(_vm._s(_vm.$t("Compare price")))
              ]),
              _c(
                "div",
                { staticClass: "field-value" },
                [
                  _c("base-checkbox", {
                    attrs: {
                      label: _vm.$t("Show products with compare price"),
                      checked: _vm.searchData.comparePrice
                    },
                    model: {
                      value: _vm.searchData.comparePrice,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "comparePrice", $$v)
                      },
                      expression: "searchData.comparePrice"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "inline-field" }, [
              _c("div", { staticClass: "field-name" }, [
                _vm._v(_vm._s(_vm.$t("Rating")))
              ]),
              _c(
                "div",
                { staticClass: "field-value rating-block" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchData.rating.sign,
                          expression: "searchData.rating.sign"
                        }
                      ],
                      staticClass: "inherit",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.searchData.rating,
                            "sign",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }),
                      _c("option", { attrs: { value: "eq_num" } }, [
                        _vm._v("=")
                      ]),
                      _c("option", { attrs: { value: "gt" } }, [_vm._v(">")]),
                      _c("option", { attrs: { value: "gte" } }, [_vm._v(">=")]),
                      _c("option", { attrs: { value: "lt" } }, [_vm._v("<")]),
                      _c("option", { attrs: { value: "lte" } }, [_vm._v("<=")])
                    ]
                  ),
                  _c("base-rating", {
                    attrs: { stars: 5 },
                    model: {
                      value: _vm.searchData.rating.value,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData.rating, "value", $$v)
                      },
                      expression: "searchData.rating.value"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "block-field" }, [
              _c("div", { staticClass: "field-value" }, [
                _c(
                  "a",
                  {
                    staticClass: "inline-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showOrderBy = !_vm.showOrderBy
                      }
                    }
                  },
                  [
                    _c("b", [
                      _c("i", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("Sort results by")) +
                            "\n                        "
                        )
                      ])
                    ]),
                    _c("i", {
                      staticClass: "gc-icon",
                      class: _vm.showOrderBy ? "darr" : "rarr"
                    })
                  ]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchData.order.type !== "",
                        expression: "searchData.order.type !== ''"
                      }
                    ],
                    staticClass: "reset red",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.searchData.order = { type: "", direction: "" }
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cancel")))]
                )
              ])
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showOrderBy,
                    expression: "showOrderBy"
                  }
                ],
                staticClass: "block-field"
              },
              [
                _c("div", { staticClass: "inline-search-fields" }, [
                  _c("div", { staticClass: "inline-field" }, [
                    _c("div", { staticClass: "field-name" }, [
                      _vm._v(_vm._s(_vm.$t("Name")))
                    ]),
                    _c("div", { staticClass: "field-value" }, [
                      _c("label", { staticClass: "mb right" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchData.order,
                              expression: "searchData.order"
                            }
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: { type: "name", direction: "asc" },
                            checked: _vm._q(_vm.searchData.order, {
                              type: "name",
                              direction: "asc"
                            })
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.searchData, "order", {
                                type: "name",
                                direction: "asc"
                              })
                            }
                          }
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("ascending")))
                      ]),
                      _c("label", { staticClass: "mb left" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchData.order,
                              expression: "searchData.order"
                            }
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: { type: "name", direction: "desc" },
                            checked: _vm._q(_vm.searchData.order, {
                              type: "name",
                              direction: "desc"
                            })
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.searchData, "order", {
                                type: "name",
                                direction: "desc"
                              })
                            }
                          }
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("descending")))
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "inline-field" }, [
                    _c("div", { staticClass: "field-name" }, [
                      _vm._v(_vm._s(_vm.$t("Price")))
                    ]),
                    _c("div", { staticClass: "field-value" }, [
                      _c("label", { staticClass: "mb right" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchData.order,
                              expression: "searchData.order"
                            }
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: { type: "price", direction: "asc" },
                            checked: _vm._q(_vm.searchData.order, {
                              type: "price",
                              direction: "asc"
                            })
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.searchData, "order", {
                                type: "price",
                                direction: "asc"
                              })
                            }
                          }
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("ascending")))
                      ]),
                      _c("label", { staticClass: "mb left" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchData.order,
                              expression: "searchData.order"
                            }
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: { type: "price", direction: "desc" },
                            checked: _vm._q(_vm.searchData.order, {
                              type: "price",
                              direction: "desc"
                            })
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.searchData, "order", {
                                type: "price",
                                direction: "desc"
                              })
                            }
                          }
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("descending")))
                      ])
                    ])
                  ])
                ])
              ]
            ),
            _c("div", { staticClass: "block-field" }, [
              _c("div", { staticClass: "field-value" }, [
                _c(
                  "a",
                  {
                    staticClass: "inline-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showFeatures = !_vm.showFeatures
                      }
                    }
                  },
                  [
                    _c("b", [
                      _c("i", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Additional search parameters")) +
                            "\n                    "
                        )
                      ])
                    ]),
                    _c("i", {
                      staticClass: "gc-icon",
                      class: _vm.showFeatures ? "darr" : "rarr"
                    })
                  ]
                )
              ])
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFeatures,
                    expression: "showFeatures"
                  }
                ],
                staticClass: "block-field"
              },
              [
                _vm.isDataLoading
                  ? _c("div", { staticClass: "loader" })
                  : _c(
                      "div",
                      { staticClass: "inline-search-fields" },
                      _vm._l(_vm.features, function(feature, key) {
                        return _c(
                          "div",
                          { key: key, staticClass: "inline-field" },
                          [
                            _c("div", { staticClass: "field-name" }, [
                              _vm._v(_vm._s(feature.name))
                            ]),
                            _c(
                              "div",
                              { staticClass: "field-value" },
                              [
                                _c("multiselect", {
                                  attrs: {
                                    placeholder: _vm.$t("Select value"),
                                    label: "name",
                                    "track-by": "id",
                                    options: feature.values,
                                    showLabels: false,
                                    multiple: true
                                  },
                                  model: {
                                    value:
                                      _vm.searchData.features[
                                        key + "***" + feature.id
                                      ],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchData.features,
                                        key + "***" + feature.id,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "searchData.features[key + `***` + feature.id]"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
              ]
            )
          ]),
          _c("base-submit-block", {
            attrs: {
              button: _vm.$t("Search"),
              data: _vm.searchData,
              saveUrl: _vm.settings.urls.search_products,
              options: {
                buttonClass: "blue",
                statesText: {
                  saved: _vm.$t("Done"),
                  disabled: _vm.$t("Wait, please. Data is loading...")
                },
                autoSubmit: _vm.autoSubmit
              },
              disabled: _vm.isDataLoading || _vm.isSelectedLoading
            },
            on: {
              "update:data": function($event) {
                _vm.searchData = $event
              },
              saved: _vm.initSearchResults,
              "pre-save": function($event) {
                _vm.products = []
                !_vm.autoSubmit && (_vm.searchData.page = 1)
              }
            }
          })
        ],
        1
      ),
      !_vm.isSelectedLoading
        ? _c("results", {
            attrs: {
              products: _vm.products,
              type: _vm.searchType,
              pagination: _vm.pagination,
              settings: _vm.settings
            },
            on: {
              "page-changed": function($event) {
                return _vm.onPageChanged($event)
              }
            }
          })
        : _c("div", { staticClass: "big-loader" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }